export type PantoneColors = {
  code?: string;
  hex?: string;
  name?: string;
};

export enum AiProductSource {
  REMIX = 'REMIX',
  DESIGNATTRIBUTE = 'DESIGNATTRIBUTE',
  DESIGNSTUDIO = 'DESIGNSTUDIO',
  DESIGNSKETCH = 'DESIGNSKETCH',
  DESIGNEXISTING = 'DESIGNEXISTING',
  DESIGNTEMPLATE = 'DESIGNTEMPLATE',
  DESIGNCOMMUNITY = 'DESIGNCOMMUNITY',
  NONE = 'NONE',
  CREATION = 'CREATION',
  TSHIRT = 'TSHIRT',
  COLORCHANGE = 'COLORCHANGE',
}
export interface AiProductProps {
  title: string;
  description: string;
  imageUrl?: string;
  materials?: string[];
  designDetails?: string[];
  manufacturingCost?: string;
  ideaId?: number;
  id?: number;
  _id?: number;
  uploadedImage?: string;
  uploadedImageDescription?: string;
  categoryName?: string;
  source: AiProductSource;
  attributes?: string[];
  pantoneColors?: PantoneColors[];
  sortIndex?: number;
  _specError?: any;
  _specLoading?: boolean;
  isPrivate?: boolean;
  constructionSpecifications?: string[];
  packagingDetails?: string;
  originId?: number;
}

export interface AiIdeaProps {
  id: number;
  userId: number;
  anonymousUserId: number | null;
  title: string | null;
  description: string | null;
  profitMargin: number;
  isPrivate: boolean;
  isSubmited: boolean;
  selectedProductIds: number[] | null;
  suggestedProductIdeas: string[];
  variations: any[] | null;
  createdAt: string;
  updatedAt: string;
  products: AiProductProps[];
}

export interface AiIdeaResponseProps {
  meta: any;
  total: number;
  pages: number;
  size: number;
  pageNum: number;
  pageSize: number;
  startRow: number;
  endRow: number;
  list: AiIdeaProps[];
}

export interface GenerateGptImagesResponse {
  message: string;
}

export enum AIToolsContent {
  ATTRIBUTE_DEL = 'ATTRIBUTE_DEL',
  ATTRIBUTE_ADD = 'ATTRIBUTE_ADD',
  GENERATE = 'GENERATE',
  STYLE_CHANGE = 'STYLE_CHANGE',
  SEARCH = 'SEARCH',
  SEARCH_EMPTY = 'SEARCH_EMPTY',
  SEARCH_HOT = 'SEARCH_HOT',
  DOWNLOAD = 'DOWNLOAD',
  START_DESIGNING = 'START_DESIGNING',
  TRY_AI_T_SHIRT_DESIGN_GENERATOR = 'TRY_AI_T_SHIRT_DESIGN_GENERATOR',
  LINKS = 'LINKS',
  GET_IT_MADE = 'GET_IT_MADE',
  REVERSE = 'REVERSE',
  PAGE_CHANGE = 'PAGE_CHANGE',
  UPLOAD_COMPLETE = 'UPLOAD_COMPLETE',
}

export interface LinkProps {
  title: string;
  href: string;
}

export enum AIToolsFabricPatternChangerModeProps {
  AUTO = 'AUTO',
  BY_DESCRIPTION = 'BY_DESCRIPTION',
  BY_IMAGE = 'BY_IMAGE',
}

export enum AIToolsClothingModelGeneratorCategoryProps {
  UPPER_BODY = 0,
  LOWER_BODY = 1,
  DRESS = 2,
}

export enum AIToolsClothingModelGeneratorModelTypeProps {
  HD = 'hd',
  DC = 'dc',
}

export enum AIToolsClothingModelGeneratorModelClassProps {
  CLOTH = 'cloth',
  MODEL = 'model',
}
